import CookieStorage from "@/lib/Storage/CookieStorage";

export const cookieStorage = new CookieStorage();
